var React = require('react');

function BillionPolyclusterInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M29.2415 73.4134L20.4766 96.0865L5.22352 77.1593L29.2415 73.4134Z","stroke":"#FF5A7D","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M151.988 95.4175L111.213 126.765L104.453 75.7792L151.988 95.4175Z","fill":"#B1F8FC","stroke":"#B1F8FC","strokeWidth":"2","key":1}),React.createElement("path",{"d":"M28.5731 7.96048L46.8988 12.1258L34.1286 25.9137L28.5731 7.96048Z","fill":"#C99CEF","key":2})]);
}

BillionPolyclusterInline.defaultProps = {"width":"164","height":"141","viewBox":"0 0 164 141","fill":"none"};

module.exports = BillionPolyclusterInline;

BillionPolyclusterInline.default = BillionPolyclusterInline;
